import { useContext } from 'react';

import { Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import ContactDetailsItem from 'src/types/ContactDetailsItem';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';
import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import ContentOverviewHeaderContainer from '../_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import ContentOverviewLeadCard from './_contentOverviewLeadCard/contentOverviewLeadCard';

import ContentOverviewFields from './ContentOverviewLeadsFields';

import styles from './ContentOverviewLeads.module.css';

type ContentOverviewLeadsProps = ComponentProps & {
	fields: ContentOverviewFields;
};

export default function ContentOverviewLeads(props: ContentOverviewLeadsProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const WildCardRoute = useContext(WildCardRouteContext);
	const isEditing = IsSitecoreEditing();

	if (isEditing && !props.fields) {
		return (
			<div className={styles.overviewLeadContainer}>
				<EditorHelp text={'Select a datasource to edit leads'} />
			</div>
		);
	} else if ((!isEditing && !props.fields) || (!isEditing && !props.fields.ResourceLeads && !props.fields.CourseLeads)) {
		return <></>;
	}

	let header = '';
	let text = '';
	let leads: ContactDetailsItem[] = [];

	if (props.fields?.ResourceLeads && props.fields?.ResourceLeads.length > 0) {
		header = props.fields?.ResourceLeadHeader?.value;
		text = props.fields?.ResourceLeadText?.value;
		leads = props.fields?.ResourceLeads;
	} else if (props.fields?.CourseLeads && props.fields?.CourseLeads.length > 0) {
		header = props.fields?.CourseLeadHeader?.value;
		text = props.fields?.CourseLeadText?.value;
		leads = props.fields?.CourseLeads;
	} else {
		return <></>;
	}

	return (
		<FieldEditFrame
			itemId={WildCardRoute?.wildCardItemInfo?.Id ?? sitecoreContext?.itemId ?? undefined}
			fields={['CourseLeads', 'ResourceLeads']}
			header="Edit Leads"
		>
			<div className={styles.overviewLeadContainer}>
				<EditorHelp text={'Click here to select leads'} />
				<ContentOverviewHeaderContainer header={header} subHeader={text} />
				{leads?.map((lead, index) => (
					<ContentOverviewLeadCard
						key={index}
						lead={lead}
						index={index}
						pageTitle={
							WildCardRoute?.wildCardItemInfo
								? WildCardRoute.wildCardItemInfo.Title
								: props.rendering.fields?.PageTitle
								? (props.rendering.fields?.PageTitle as Field<string>).value
								: ''
						}
						contactEmailAddressText={props.fields?.ContactEmailAddressText}
						contactEmailSubjectText={props.fields?.ContactEmailSubjectText}
					/>
				))}
			</div>
		</FieldEditFrame>
	);
}
